import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCxfIIq0tWl_UzJOz8aL_RTTx1-1nqfF5A",
  authDomain: "arush-a3364.firebaseapp.com",
  projectId: "arush-a3364",
  storageBucket: "arush-a3364.firebasestorage.app",
  messagingSenderId: "535168702619",
  appId: "1:535168702619:web:6ba735575c04493b3bce3e",
  measurementId: "G-QFR4BWFQDV"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);